/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Agents_Role_AppendsInputs */



/**
* | output |
* | --- |
* | "Adds rows" |
*
* @param {Datasets_Agents_Role_AppendsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_agents_role_appends = /** @type {((inputs?: Datasets_Agents_Role_AppendsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Agents_Role_AppendsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügt Zeilen hinzu")
	return /** @type {LocalizedString} */ ("Adds rows")
});